

function getUniqueSections(media = []) {
  const text = /^[0-9]+$/;
  return media.map(el => {
    const { title = '' } = el || {};
    const splitTitleArr = title.split('-');
    const yearValue = splitTitleArr.length > 1 ? String(splitTitleArr[splitTitleArr.length - 1]).trim() : '';
    if (String(yearValue).length !== 4 || !text.test(yearValue)) {
      return { sectionTitle: 'General', sectionData: el };
    }
    return { sectionTitle: String(yearValue), sectionData: { ...el, title: splitTitleArr.slice(0, splitTitleArr.length - 1).join('-') } };
  });
}

function getMediaCenterCategories(singleMediaSection) {
  const { images = [], documents = [] } = singleMediaSection;
  const categorizedImages = getUniqueSections(images);
  const categoriezedDocuments = getUniqueSections(documents);
  const uniqueSectionsForImages = categorizedImages.map(el => el.sectionTitle);
  const uniqueSectionsForDocuments = categoriezedDocuments.map(el => el.sectionTitle);
  const uniqueSections = uniqueSectionsForImages.concat(uniqueSectionsForDocuments).filter((value, index, self) => self.indexOf(value) === index).sort((a, b) => {
    const firstItem = isNaN(a) ? 0 : parseFloat(a);
    const secondItem = isNaN(b) ? 0 : parseFloat(b);
    return secondItem - firstItem;
  });
  const resultArray = uniqueSections.map(el => {
    const sectionImages = categorizedImages.filter(img => img.sectionTitle === el).map(sec => sec.sectionData);
    const sectionDocs = categoriezedDocuments.filter(img => img.sectionTitle === el).map(sec => sec.sectionData);
    return {
      title: el,
      images: sectionImages || [],
      documents: sectionDocs || []
    };
  }).filter(el => el.images.length > 0 || el.documents.length > 0);
  return resultArray;
}
function parseMediaCenterData(data) {
  if (data) {
    const formattedData = data.map(el => ({ ...el, images: (el.images || []).map(i => ({ ...i, image: i['image-url'] })), documents: (el.documents || []).map(d => ({ ...d, document: d.url || d['document-url'] })) }));
    return formattedData.map(el => ({
      ...el,
      categorizedMedia: getMediaCenterCategories(el)
    }));
  }
  return [];
}
export { parseMediaCenterData, getMediaCenterCategories };



// WEBPACK FOOTER //
// ./app/utils/mediaCenter.js